import { FeatureContainer } from "@kaltura/mediaspace-shared-styled";
import { systemWidth } from "@kaltura/mediaspace-shared-styled";
import { ExploreSideBarLayout } from "@kaltura/mediaspace-shared-search";
import { Typography } from "@kaltura/ds-react-components";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";
import styled from "@emotion/styled";
import { StatusScreen } from "@kaltura/mediaspace-shared-ui";

export const RecycleBinContainer = styled(FeatureContainer)(({ theme }) => ({
    ...systemWidth({ theme }),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
}));

export const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2.5),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(3),
    },
}));

export const Title = styled(Typography)({
    margin: 0,
});

export const ContentContainer = styled(ExploreSideBarLayout)(({ theme }) => ({
    flexGrow: 1,
    [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(1),
    },
}));

export const ContentFiltersContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ theme, inModal }) => ({
    display: "flex",
    flexDirection: inModal ? "column" : "row",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
    },
}));

export const FiltersContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ theme, inModal }) => ({
    width: inModal ? "100%" : 205,
    marginRight: theme.spacing(4),
    flexGrow: 0,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        width: "100%",
    },
}));

export const SearchFormContainer = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "inModal";
        },
    }
)<{ inModal?: boolean }>(({ inModal, theme }) => ({
    marginBottom: inModal ? 0 : theme.spacing(3),
    [theme.breakpoints.down("md")]: {
        marginBottom: 0,
    },
}));

export const ResultsContainer = styled("div")({
    flex: "1 1 0",
    minWidth: 0,
    "&:focus-visible": VisibleFocusStyle,
});

export const NoResultsScreen = styled(StatusScreen)({
    "& svg": {
        width: 300,
        height: 300,
    },
});
